module.exports = __webpack_public_path__ + "img/icons8-basket-96.da2f87e3.png";